module.exports = __webpack_public_path__ + "media/images/brand/logo-reverse-nav-95ee40a22f12f00175dd8d94ef0af941.svg";